/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_Field_PaidInputs */

const en_lesson_field_paid = /** @type {(inputs: Lesson_Field_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid`)
};

const he_lesson_field_paid = /** @type {(inputs: Lesson_Field_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שולם`)
};

/**
* | output |
* | --- |
* | "Paid" |
*
* @param {Lesson_Field_PaidInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_field_paid = /** @type {((inputs?: Lesson_Field_PaidInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_Field_PaidInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_field_paid(inputs)
	return he_lesson_field_paid(inputs)
});